export default __webpack_public_path__ + "static/media/doctor-res.d8deb059.svg";